'use strict';

module.exports = require('./dist/openchemlib-full');
